import React, { useContext, useState } from "react";
import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../css/Commission.css";
import ExtraActivityContext from "../contextfolder/ExtraActivityContext/ExtraActivityContext";
import MarksInputContext from "../contextfolder/MarksInputContext/MarksInputContext";
import ExtraActivity from "../ExtraActivity/ExtraActivity";
import MarksInput from "../MarksInput/MarksInput";
import SidebarContext from "../sidebarcontext/SidebarContext";
import "../TabbedView/TabbedView.css";
import ExtraActMonth from "../ExtraActMonth/ExtraActMonth";
import ExtraActMonthContext from "../contextfolder/ExtraActMonthContext/ExtraActMonthContext";
import AttenInput from "../AttenInput/AttenInput";
import AttenInputContext from "../contextfolder/AttenInputContext/AttenInputContext";
import LogBookList from "./Manual/LogBookList";
import LogPhotoList from "./Image/LogPhotoList";
import AcademicHeader from "../AcademicHeader";

export default function LogBook() {
  const { AcademicYear, todayDate } = useContext(SidebarContext);

  const { setIsSubmit, isSubmit, fetchdata, marksInputList, setMarkList } =
    useContext(MarksInputContext);
  const {
    setIsAttenSubmit,
    isAttenSubmit,
    fetchAttendata,
    attenInputList,
    setAttenList,
  } = useContext(AttenInputContext);

  const { setEisSubmit, isEsubmit, fetchExtradata, eList } =
    useContext(ExtraActivityContext);
  const { setMisSubmit, isMsubmit, fetchMExtradata, mList } =
    useContext(ExtraActMonthContext);

  const [activeTab, setActiveTab] = useState({
    tab1: true,
    tab2: false,
  });
  const handleTab1 = () => {
    setActiveTab({
      tab1: true,
      tab2: false,
    });
  };
  const handleTab2 = () => {
    setActiveTab({
      tab1: false,
      tab2: true,
    });
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
      />
      <div className="col-lg-12 col-md-12 col-sm-12 contentMainSection">
        <div className="row">
          <div className="page-header">
            <div className="text-start  page-title">Log Book</div>
            <div className="page-date">
              <div className="sec-content">
                <AcademicHeader
                  todayDate={todayDate}
                  AcademicYear={AcademicYear}
                />
              </div>
            </div>
          </div>
        </div>
        <hr />

        <div className="tabview ">
          <div className="insidePopup--div">
            <ul>
              <li
                className={activeTab.tab1 === true ? "active" : ""}
                onClick={handleTab1}
              >
                <i className="fa fa-file-text-o mr-1 icon"></i>Manual{" "}
              </li>
              <li
                className={activeTab.tab2 === true ? "active" : ""}
                onClick={handleTab2}
              >
                <i className="fa fa-file-text-o mr-1 icon"></i>Image
              </li>
            </ul>
          </div>
        </div>

        <div className="content-section main-content">
          {activeTab.tab1 && <LogBookList />}
          {activeTab.tab2 && <LogPhotoList />}
        </div>
      </div>
    </>
  );
}
